import { render, staticRenderFns } from "./menber_detail.vue?vue&type=template&id=645ed032&scoped=true"
import script from "./menber_detail.vue?vue&type=script&lang=js"
export * from "./menber_detail.vue?vue&type=script&lang=js"
import style0 from "./menber_detail.vue?vue&type=style&index=0&id=645ed032&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645ed032",
  null
  
)

export default component.exports